// The widget's version, shown in the panel and sent with every piece of feedback
// (`meta.widgetVersion`). It comes from package.json, which the build workflow stamps
// (`npm version` in build-angular-app.yml), so a deployed build reports its real
// version while local builds read 0.0.0.
//
// A default import because webpack rejects named imports from JSON. Webpack still
// tree-shakes the manifest down to the one property read here.
import packageManifest from '../../package.json';

export const WIDGET_VERSION: string = packageManifest.version;
